import React, { useEffect, useRef } from 'react';
import './code-editor.scss';
import AceEditor from 'react-ace';
import { useAppSelector } from '../../../store';
import 'brace/mode/ini';
import 'brace/mode/html';
import 'brace/theme/tomorrow_night';
import 'brace/theme/tomorrow';
import 'ace-builds/src-noconflict/ext-searchbox';
import { Box, Stack, Typography } from '@mui/material';
import ShowContainer from '../ShowContainer';
import CusTooltip from '../CusTooltip';
import { useTranslation } from 'react-i18next';

export default function CodeEditor({
  mode = 'ini',
  text,
  setText,
  tooltipText,
  height,
  label,
  isOpenFind = true,
  readOnly,
  isVerySmall
}) {
  const { t } = useTranslation();
  const activeMode = useAppSelector((state) => state.customizer.activeMode);
  const aceRef = useRef(null);

  const handleSearch = () => {
    if (!isOpenFind) return;
    if (aceRef.current) {
      const editor = aceRef.current.editor;
      editor.execCommand('find');
    }
  };

  useEffect(() => {
    handleSearch();
  }, [aceRef]);

  return (
    <Box>
      <Stack display={'flex'} direction={'column'} gap={isVerySmall ? 0 : 0.5}>
        <ShowContainer condition={label}>
          <Stack
            display={'flex'}
            alignItems={'center'}
            flexDirection={'row'}
            gap={0.5}
            flexWrap={'wrap-reverse'}>
            <Typography color="textSecondary" fontSize={isVerySmall ? 12 : undefined}>
              {t(label)}
            </Typography>
            {tooltipText && <CusTooltip text={tooltipText} />}
          </Stack>
        </ShowContainer>
        <AceEditor
          ref={aceRef}
          mode={mode}
          theme={activeMode == 'dark' ? 'tomorrow_night' : 'tomorrow'}
          fontSize={12}
          value={text}
          showPrintMargin={false}
          width={'100%'}
          style={{ minHeight: '250px' }}
          height={height}
          onChange={(val) => setText(val)}
          readOnly={readOnly}
        />
      </Stack>
    </Box>
  );
}
